// loading.service.ts
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

@Injectable({ providedIn: 'root' })
export class LoadingService {
  private _loading = false;

  get loading(): boolean {
    return this._loading;
  }

  start(): void {
    this._loading = true;
  }

  stop(): void {
    this._loading = false;
  }
}
